import { jsx as _jsx } from "react/jsx-runtime";
import { RawHTML } from '@wordpress/element';
import { useBlockProps } from '@wordpress/block-editor';
export default function MeetingSaveBlock({ attributes, }) {
    const { url } = attributes;
    if (url) {
        return (_jsx(RawHTML, { ...useBlockProps.save(), children: `[hubspot url="${url}" type="meeting"]` }));
    }
    return null;
}
